import { FilterChip } from '@cibo/ui'
import { ChipProps } from '@mui/material'
import { useFarm } from '../../../../queries'

type FarmChipProps = ChipProps & {
  termsetId: string
}

export const FarmChip = ({ termsetId, ...chipProps }: FarmChipProps) => {
  const termset = useFarm(termsetId)

  if (!termset.data) return null

  return <FilterChip label={termset.data.name} {...chipProps} />
}
